export const PLATFORM_LIVE_CHANNELS = {
	HEALTH_ALERTS: 'resources/health-alerts',
	USER_NOTIFICATIONS: 'resources/user-notifications',
	CONNECTION: 'live/connection',
} as const
